<script>
	import { createEventDispatcher, tick } from "svelte";
	import lookups from "../../../stores/lookupStore";

	import FormRow from "../../../components/FormRow.svelte";
	import FormColumn from "../../../components/FormColumn.svelte";
	import DatePickerMonth from "../../../components/DatePickerMonth.svelte";
	import Select from "../../../components/Select.svelte";
	import AddButton from "../../../components/buttons/AddButton.svelte";
	import DeleteButton from "../../../components/buttons/DeleteButton.svelte";

	export let childCareCentres = [];
	export let disabled = false;

	const dispatch = createEventDispatcher();

	function addCentre() {
		childCareCentres = [...childCareCentres, { id: null, yearStart: null, yearEnd: null }];
	}

	function deleteCentre(i) {
		childCareCentres.splice(i, 1);
		childCareCentres = [...childCareCentres];
	}

	// Function to handle input changes and dispatch event (if needed for DatePickers)
	function handleInput() {
		childCareCentres = [...childCareCentres]; // Ensure reactivity if direct binding isn't enough
		dispatch("change", childCareCentres);
	}
</script>

{#if childCareCentres && childCareCentres.length > 0}
	{#each childCareCentres as centre, i (i)}
		<FormRow>
			<FormColumn cols="11">
				<Select
					required
					{disabled}
					label="What daycare centre(s)/service(s) did the impacted child attend?"
					id="id{i}"
					optionList={$lookups.childCareCentre}
					textProperty="label"
					valueProperty="value"
					bind:value={centre.id} />
			</FormColumn>
			<FormColumn cols="1">
				{#if !disabled && childCareCentres.length > 1}
					<DeleteButton
						style="margin-top:40px; font-size: 1.2rem; color: var(--color-primary)"
						on:delete={() => deleteCentre(i)} />
				{/if}
			</FormColumn>
		</FormRow>
		<FormRow class="mt-1 align-items-end">
			<FormColumn cols="5">
				<label class={i == 0 ? "date-label" : "date-label displaynone"} for={"startDate" + i}>Start Date</label>
				<DatePickerMonth
					{disabled}
					required
					start={new Date(2017, 0, 1)}
					end={new Date()}
					name={"startDate" + i}
					id={"startDate" + i}
					openOnClass="calendar-icon"
					validator={"startDate"}
					validatorMessage="End date cannot be before the start date"
					bind:formattedSelected={centre.yearStart}
					on:change={handleInput} />
			</FormColumn>
			<FormColumn cols="1" class="text-center">
				<p class="label" style="margin-top:40px">to</p>
			</FormColumn>
			<FormColumn cols="5">
				<label class={i == 0 ? "date-label" : "date-label displaynone"} for={"endDate" + i}>End Date</label>
				<DatePickerMonth
					required
					{disabled}
					start={new Date(2017, 0, 1)}
					end={new Date()}
					name={"endDate" + i}
					id={"endDate" + i}
					openOnClass="calendar-icon"
					validator="endDate"
					validatorMessage="End date cannot be before the start date"
					bind:formattedSelected={centre.yearEnd}
					on:change={handleInput} />
			</FormColumn>
		</FormRow>
	{/each}

	{#if !disabled}
		<FormRow class="mt-2">
			<FormColumn class="last">
				<AddButton on:add={() => addCentre()}>Add a Child Care Centre</AddButton>
			</FormColumn>
		</FormRow>
	{/if}
{/if}
